import { render, staticRenderFns, recyclableRender, components } from "./withdraw.vue?vue&type=template&id=65f6c840&scoped=true&"
var renderjs
import script from "./withdraw.vue?vue&type=script&lang=js&"
export * from "./withdraw.vue?vue&type=script&lang=js&"
import style0 from "./withdraw.vue?vue&type=style&index=0&lang=css&"
import style1 from "./withdraw.vue?vue&type=style&index=1&id=65f6c840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f6c840",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pagesA/pages/withdraw/withdraw.vue"
export default component.exports